import { useSelector } from "react-redux";
import { AppState } from "store";

function useOldSupporDialogHelper() {
  const hasOldSupportDialog = useSelector((store: AppState) => store.auth.selectedCompany.isAgentSalesActive);

  return { hasOldSupportDialog };
}

export default useOldSupporDialogHelper;
